import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

import { MessageType } from "./Message";

function ImageMessage(props) {
  const [imgMsgState, setImgMsgState] = useState({
    imgSrc: "",
  });

  useEffect(() => {
    if (
      props?.message?.message?.text !== null &&
      props?.message?.message?.text
    ) {
      setImgMsgState(prev => ({ ...prev, imgSrc: props?.message?.message?.text }));
    }
  }, []);

  const showImageInNewTab = () => {
    const { imgSrc } = imgMsgState;

    let imageLink = imgSrc;
    if (!imageLink) {
      return;
    }
    window.open(imageLink, "_blank");
  };

  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return  "s360-message-box-sent";
      case MessageType.received:
        return  s360ConfigService.config.autoFullScreen?"s360-message-box-received-fs": "s360-message-box-received";
      case MessageType.info:
        return "s360-message-box-info";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.sent:
        return {
          height: "105px",
          background: "#FFFFFF",
          ...config?.customDesign?.imageMessageBoxReceiver
        };
      case MessageType.received:
        return {
          height: "105px",
          background: "#FFFFFF",
          ...config?.customDesign?.imageMessageBoxSender
        };
      default:
        return {};
    }
  };

  // const messageContainerStyle = () => {
  //   // let config = props.config

  //   return {};
  // };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.imageMessageTime
      default:
        return {};
    }
  };

  const { imgSrc } = imgMsgState;

  return (
    <div className={messageContainerClassName()}>
      <div
        className={messageBoxClassName()}
        style={messageBoxStyle()}
        onClick={showImageInNewTab}
      >
        {props.isOnlyEmoji ? (
          <div>{imgSrc}</div>
        ) : (
          <img
            style={{ objectFit: "contain", width: "100%" }}
            width="100%"
            height="100%"
            src={imgSrc}
            alt="imgSrc"
          />
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(
                  props?.message?.message?.sentTimestamp / 1000
                )
              )
              .format("DD MMM h:mm a")}
          </div>
        )}

        {/* <Retry {...props} /> */}
      </div>
    </div>
  );
}

export default ImageMessage;
